import { ApplyCouponPotentialCommsType } from "@swiggy-private/cart-types";
import { BaseTheme } from "@swiggy-private/dls-web-common/dist/components/themes/precomputed/Base/BaseTheme";
import { DialogButtonTypes } from "@swiggy-private/native-bridge";
export enum BUTTON_IDS {
    YES = "1",
    NO = "2",
}

export const RemoveCouponModalData = {
    message: "Are you sure you want to remove the applied coupon?",
    buttonLabels: [
        {
            id: BUTTON_IDS.YES,
            text: "Yes",
            type: DialogButtonTypes.PRIMARY,
        },
        {
            id: BUTTON_IDS.NO,
            text: "No",
            type: DialogButtonTypes.SECONDARY,
        },
    ],
};

export const confettiMapping = {
    CONFETTI_TYPE_TOP_UP: "TOP_UP_COUPON",
    CONFETTI_TYPE_AUTO_APPLY: "AUTO_APPLY_COUPON",
};

export const SWIGGY_ONE_CONFETTI = "APPLY_SWIGGY_ONE";
export const SWIGGY_BLACK_CONFETTI = "APPLY_SWIGGY_BLACK";

export const SAVINGS_BANNER_YAY = "CartPageAssets/SavingsBannerYay";

export const ERROR_TEXT = {
    DEFAULT: "Oops, something is wrong",
    TRY_THIS: "Try this instead",
    CONSIDER_THIS: "Consider this instead",
};

export const CART_RELOAD_TIME_REDIRECTION_MS = 60000;
export const DISCOUNTING_TOAST_DURATION = 4000;

export enum CouponType {
    RESTAURANT = "RESTAURANT",
    PAYMENT = "PAYMENT",
}

export const APPLY_COUPON_TEXTS = {
    TITLE: "APPLY COUPON",
    PAYMENT_COUPONS_PAGE_TITLE: "Payment offers",
    SUB_TITLE: "Your cart: \u20B9{0}",
    TOTAL_PAYABLE_SUB_TITLE: "Total payable: \u20B9{0}",

    // Cart 2.0 constants
    VIEW_ALL_COUPONS: "View all coupons",
    VIEW_ALL_RESTAURANT_COUPONS: "View all restaurant coupons",
    VIEW_ALL_PAYMENT_COUPONS: "View all payment coupons",
    ADD_ITEM: "Add Item",
    SAVE_ON_ORDER_WITH_EXTRA_SAVINGS: "Save {0} on this order + extra {1} on next order",
    SAVE_ON_ORDER: "Save {0} on this order",
    APPLY: "Apply",
    APPLY_ALL: "Apply all",
    SAVE_ANOTHER_X_WITH_COUPON: "Save another {0} with {1}",
    SAVE_X_WITH_COUPON: "Save {0} with {1}",
    SAVE_X_WITH_Y_COUPON_CODES: "Save {0} with {1} coupons",
    APPLY_COUPON: "Apply Coupon",
    X_APPLIED: "'{0}' applied",
    X_SAVED_WITH_COUPON: "{0} saved with {1}",
    X_SAVED_WITH_Y_COUPON_CODES: "{0} saved with {1} coupons",
    UNLOCK_COUPON_WITH_X: "Unlock {0} with items worth {1}",
    X_OFF_ON_NEXT_ORDER: "{0} off on next order",
    EXPIRES_IN_DAYS: "Expires in {0} days",
    EXTRA_SAVINGS_TOOLTIP_CONTENT: "This discount will get applied automatically when you order again within {0} days.",
    X_SAVED_WITH_BENEFIT: "{0} saved with '{1}'",
    X_SAVED_INCLUDING_BENEFIT: "{0} saved including '{1}'",
    X_SAVED_ON: "{0} saved on '{1}'",
    APPLIED: "Applied",
    ENDS_IN: "Ends in {0}",
};

export const TD_COUPON_MODAL = {
    TD_COUPON_MODAL: "tdCouponModal",
};

export const EMPTY_COUPON_PAGE_TITLE = "No Offers";
export const EMPTY_COUPON_PAGE_SUBTITLE = "Exciting new offers are coming your way!";

export const CROUTON_IMG = "CancellationPolicyAssets/arrow_crouton67_5x";

export const COUPON_CROUTON_TEXT = "View Add-On {0}";

export const SAVINGS_COUPON = "savings-coupon";

export const FTUE_FOOTER_COMMS_FOR_POR_2 = {
    text: "Use payment coupon to save more!",
    icon: "{{img|63px|27px|portal/m/ftue_icon.png}}",
    /* eslint-disable @typescript-eslint/naming-convention */
    background_color: BaseTheme.colors[BaseTheme.colorMode].background_inverse_Primary,
    text_color: BaseTheme.colors[BaseTheme.colorMode].text_inverse_Highest_Emphasis,
    type: ApplyCouponPotentialCommsType.FTUE,
    closeIconColor: BaseTheme.colors[BaseTheme.colorMode].text_inverse_Med_Emphasis,
    closeIconSize: 28,
    cloudinaryId: "portal/m/60x36.png",
    /* eslint-enable @typescript-eslint/naming-convention */
};

export const GIFTING_SAVINGS_PLACEHOLDER = {
    TOTAL_SAVINGS: "{{totalSavings}}",
    COUPON_COUNT: "{{couponCount}}",
};
